// extracted by mini-css-extract-plugin
export default {"container":"CampaignActivity_container__SRo1r"};